import React from "react";

import { postsApi } from "api/instances";
import DownloadButton from "modules/common/components/buttons/muiDownloadButton";
import { FileDownloader } from "utils/fileDownloader";
import { connect, ConnectedProps } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";

const DownloadReports: React.FunctionComponent<PropsWithRedux> = props => {
    const onClick = async () =>
        await postsApi.GetPostsCSV(props.publishedPostFilters);

    return (
        <DownloadButton
            fileType={FileDownloader.DEFAULT_FILE_TYPE}
            text="Download Reports"
            onClick={onClick}
            downloadName={`sparrow-posts-${new Date().toLocaleString().replaceAll(/, | /g, "/")}.csv`}
        />
    );
};

interface IDownloadReports { }

const connector = connect(
    (state: GlobalApplicationState, ownProps: IDownloadReports) => ({
        ...ownProps,
        publishedPostFilters: state.posts.publishedPostList.filters,
    }),
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(DownloadReports);
